/**
 * This is the entry point for specific javascript of theme
 */
import './mm-size-localization.js';
import './mm-store-messages.js';
import './mm-wishlist-card.js';
import './mm-share.js';

console.log('M-M Theme')

// console.log(navigator.languages);